import React, { useEffect, useRef, useState } from 'react';
import './css/home.css';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import firstsectionImg from '../assets/imges/1.png';
import googleImg from '../assets/imges/google.png';
import wayfair from '../assets/imges/wayfir.png';
import pantheon from '../assets/imges/panthom.png';
import monat from '../assets/imges/monat.png';
import recruit from '../assets/imges/recruit.png';
import heinonen from '../assets/imges/heinonen.png';
import googleSS from '../assets/imges/google-ss.png';
import twitterSS from '../assets/imges/twitter-1-ss.jpg';
import linkedinSS from '../assets/imges/linkedin-1-ss.jpg';
import SevenImg from '../assets/imges/Email-Marketing-Powerful-Image-2.webp';
import eightYahoo from '../assets/imges/yahoo-finance-1536x563.png';
import eightMsn from '../assets/imges/msn-1536x567.png';
import eightCxo from '../assets/imges/cxo-logo-1-1536x251.png';
import nineImg from '../assets/imges/nine-img.jpg';
import tenImg from '../assets/imges/tenSecImg.jpg';
import elevenImg from '../assets/imges/imgEleven.jpg';
import twelwImg from '../assets/imges/imgTwelw.jpg';
import fifteenImg from '../assets/imges/fifteenImg.png';
import sixteenImg from '../assets/imges/sixteenIMG.png';
import seventeenImg from '../assets/imges/seventeenImg.png';
import eighteenImg from '../assets/imges/eighteenIMG.jpg';
import nineteenImg from '../assets/imges/nineteenIMG.png';
import twentyoneGoogle from '../assets/imges/glg-img.png';
import twentyoneWay from '../assets/imges/way-img.png';
import twentyonePan from '../assets/imges/pan-img.png';
import twentyoneRec from '../assets/imges/rec-img.png';
import twentyoneHein from '../assets/imges/hein-img.png';
import twentyoneReal from '../assets/imges/real-img.png';
import arrowRight from '../assets/imges/aroowRIght_light.svg';
import lastSEcImg from '../assets/imges/lastSecImg.webp';
import Person1 from '../assets/imges/persone1Img.webp';
import person2 from '../assets/imges/person2Img.webp';
import person3 from '../assets/imges/person3img.webp';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const Home = () => {

    const sectionRef = useRef();

    useEffect(() => {
      const handleScroll = () => {
        const section = sectionRef.current;
        const images = section.querySelectorAll('.second-sec-img');
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
  
        images.forEach((img) => {
          const scaleFactor = Math.min(
            1 + ((windowHeight - sectionTop) / windowHeight) * 0.25,
            1.25
          );
          img.style.transform = `scale(${scaleFactor})`;
        });
      };
  
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    
    const AccordionItem = ({ question, answer }) => {
        const [isOpen, setIsOpen] = useState(false);
    
        return (
        <div className={`accordian_item ${isOpen ? 'open' : ''}`}>
            <div className="accordian_header" onClick={() => setIsOpen(!isOpen)}>
            <p>{question}</p>
            <span className={`arrow ${isOpen ? 'rotate' : ''}`}>
                <img src={arrowRight} alt="Toggle Arrow" />
            </span>
            </div>
            <div className="accordian_contant">
            <p>{answer}</p>
            </div>
        </div>
        );
    };

    const items = [
        {
            question: 'What kind of ROI should I expect?',
            answer:
            'Your return on investment depends on how actively you leverage your enhanced online presence. Clients typically experience faster access to key decision-makers, stronger networks, reduced sales cycles, increased engagement, higher speaking fees, and improved credibility—all contributing to long-term business growth.',
        },
        {
            question: 'How soon will I see results?',
            answer: 'You’ll receive your tailored deliverables within 7 days, allowing you to start using them immediately. Most clients notice increased visibility, engagement, and opportunities within the first few weeks.',
        },
        {
            question: 'Is the solution guaranteed?',
            answer: 'Yes, all deliverables are fully guaranteed to ensure you receive a professional, credible, and optimized online presence.',
        },
        {
            question: 'How much time will this require from me?',
            answer: 'Typically 1-2 hours per month—to stay engaged and maximize your presence. ',
        },
        {
            question: 'Are there any additional fees?',
            answer: 'No, there are no hidden fees. Our pricing is transparent, with a simple monthly rate and flexible commitments of either 3 or 12 months.',
        },
        {
            question: 'Can I cancel at any time?',
            answer: 'You can choose between a 3-month or 12-month commitment.',
        },
    ];


    return (
        <>
            <Header />

            {/* first section  */}
            <section className='firstSection overflow-hidden'>
                <div className=''>
                    <div className='inner_first custome_container'>
                        <div className='left d-flex justify-content-start align-items-start flex-column'>
                            <p>Executive Online Reputation Management</p>
                            <h1 className='firstSection-title text-start'>Name Online Reputation <br></br> Report</h1>
                        </div>
                        <div className='right d-flex justify-content-end align-items-center'>
                            <img src={firstsectionImg} className='img-mobile'></img>
                        </div>
                    </div>
                    <div className='img-section-first'>
                        <img src={firstsectionImg} alt='img'></img>
                    </div>
                </div>
            </section>

            {/* second section  */}
            <section className='secondSection overflow-hidden' id="who" ref={sectionRef}>
                <div className='custome_container'>
                    <div className='inner_second d-flex justify-content-between align-items-center flex-column position-relative'>
                    <p> —  Executive Online Reputation Management</p>
                    <h2 className='secondSection-title'>We Manage the Online Presence of Executives Across The Globe</h2>

                    {/* Images */}
                    <div className='google-img position-absolute second-sec-img'>
                        <img src={googleImg} alt='Google' />
                    </div>
                    <div className='wayfair-img position-absolute second-sec-img'>
                        <img src={wayfair} alt='wayfair' />
                    </div>
                    <div className='pantheon-img position-absolute second-sec-img'>
                        <img src={pantheon} alt='pantheon' />
                    </div>
                    <div className='monat-img position-absolute second-sec-img'>
                        <img src={monat} alt='monat' />
                    </div>
                    <div className='recruit-img position-absolute second-sec-img'>
                        <img src={recruit} alt='recruit' />
                    </div>
                    <div className='heinonen-img position-absolute second-sec-img'>
                        <img src={heinonen} alt='heinonen' />
                    </div>
                    </div>
                </div>
            </section>

            {/* third section  */}
            <section className='thirdSection'>
                <div className='custome_container'>
                    <div className='inner_third d-flex justify-content-center align-items-center flex-column'>
                        <h6 className='reason-btn-type'>4 Reasons</h6>
                        <h2 className='thirdSection-title'>Why People Come To Us</h2>
                        <p>Top executives, industry leaders, and ambitious professionals turn to us to unlock game-changing career opportunities that elevate their success.</p>
                        <div className='reasons_sec d-flex'>
                            <div className='line'></div>
                            <div className='reason-box'>
                                <div className='inner_icon'>
                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-suitcase" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"></path></svg>
                                </div>
                                <div className='reason_num'>01</div>
                                <div className='reason_name'>Board Seats</div>
                            </div>
                            <div className='reason-box'>
                                <div className='inner_icon'>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fas-microphone-alt" viewBox="0 0 352 512" xmlns="http://www.w3.org/2000/svg"><path d="M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"></path></svg>
                                </div>
                                <div className='reason_num'>02</div>
                                <div className='reason_name'>Speaking Events</div>
                            </div>
                            <div className='reason-box'>
                                <div className='inner_icon'>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fas-money-check-alt" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg"><path d="M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"></path></svg>
                                </div>
                                <div className='reason_num'>03</div>
                                <div className='reason_name'>Career Opportunities</div>
                            </div>
                            <div className='reason-box'>
                                <div className='inner_icon'>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fab-medapps" viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg"><path d="M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"></path></svg>
                                </div>
                                <div className='reason_num'>04</div>
                                <div className='reason_name'>Subject Matter Expertise</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* fourth section  */}
            <section className='fourthSection'>
                <div className='inner_fourth'>
                    <div className='custome_container'>
                        <h6>OLD</h6>
                        <h2>20th Century Benchmark​</h2>
                        <p>The outdated ways of professional growth.</p>
                        <div className='spacer'></div>
                        <div className='growth_sec'>
                            <div className='growths_box'>
                                <div className='icon_box'>
                                    <svg aria-hidden="true" className="e-font-icon-svg e-far-id-card" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"></path></svg>
                                </div>
                                <div className='growth_num'>01</div>
                                <div className='growth_title'>Improving Your Resume</div>
                            </div>
                            <div className='growths_box'>
                                <div className='icon_box'>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fas-suitcase" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"></path></svg>
                                    </div>
                                <div className='growth_num'>02</div>
                                <div className='growth_title'>Applying To Recruiters & Boards</div>
                            </div>
                            <div className='growths_box'>
                                <div className='icon_box'>
                                <svg aria-hidden="true" className="e-font-icon-svg e-far-address-book" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path d="M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"></path></svg>
                                    </div>
                                <div className='growth_num'>03</div>
                                <div className='growth_title'>Relying On Referrals & Networks</div>
                            </div>
                            <div className='growths_box'>
                                <div className='icon_box'>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    >
                                    <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM0 8h5v16H0V8zm7.5 0h4.8v2.2h.07c.67-1.27 2.3-2.6 4.73-2.6 5.06 0 6 3.33 6 7.66V24h-5v-6.8c0-1.62-.03-3.71-2.26-3.71-2.27 0-2.62 1.77-2.62 3.6V24h-5V8z"/>
                                    </svg>
                                </div>
                                <div className='growth_num'>04</div>
                                <div className='growth_title'>Posting Daily On LinkedIn</div>
                            </div>
                            <div className='growths_box'>
                                <div className='icon_box'>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fas-male" viewBox="0 0 192 512" xmlns="http://www.w3.org/2000/svg"><path d="M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"></path></svg>
                                </div>
                                <div className='growth_num'>05</div>
                                <div className='growth_title'>Word Of Mouth</div>
                            </div>
                            <div className='growths_box'>
                                <div className='icon_box'>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fas-diagnoses" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg"><path d="M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"></path></svg>
                                    </div>
                                <div className='growth_num'>06</div>
                                <div className='growth_title'>Luck & Hope</div>
                            </div>
                        </div>
                        {/* <div className='growth_spacer'></div> */}
                    </div>
                </div>
            </section>

            {/* fifth section  */}
            <section className='fifthSection'>
                <div className='inner_fifth'>
                    <div className='custome_container'>
                        <h6>New</h6>
                        <h2>21st Century Benchmark</h2>
                        <p>The new approach to professional growth.</p>
                        <div className='image_sec_fif'>
                            <div className='linkedin-img-ss'>
                                <img src={linkedinSS} alt='img'></img>
                            </div>
                            <div className='twitter-img-ss'>
                                <img src={twitterSS} alt='img'></img>
                            </div>
                            <div className='google-img-ss'>
                                <img src={googleSS} alt='img'></img>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* sixth section  */}
            <section className='sixthSection' id="report">
                <div className='inner_sixth'>
                    <h2>Name's Reputation Report</h2>
                    <p>Here is a comprehensive analysis of your entire online presence, including LinkedIn, X, and online search results.</p>
                    <div className='link_sec_six'>
                        <a href='#' className='six_link'>LinkedIn Presence</a>
                        <a href='#' className='six_link'>X Presence</a>
                        <a href='#' className='six_link'>Online Search Presence</a>
                    </div>
                </div>
            </section>

            {/* seventh section  */}
            <section className='sevenSection'> 
                <div className='inner_seven custome_container'>
                    <div className='left_seven'>
                        <p>Your Current LinkedIn Profile</p>
                        <h3>Key Issues</h3>
                        <ul>
                            <li>List Item #1</li>
                            <li>List Item #1</li>
                            <li>List Item #1</li>
                            <li>List Item #1</li>
                            <li>List Item #1</li>
                            <li>List Item #1</li>
                        </ul>
                        <a href='#'>Your LinkedIn</a>
                    </div>
                    <div className='right_seven'>
                        <div className='seven-img'>
                            <img src={SevenImg} alt='img'></img>
                        </div>
                    </div>
                </div>
            </section>

            {/* eighth section  */}
            <section className='eightSection' id="deliverables">
                <div className='inner_eight'>
                    <div className='custome_container'>
                        <h6>Deliverables</h6>
                        <h2>Expert Topics</h2>
                        <p>Defining how you position yourself in the market</p>

                        <div className='experts_sec'>
                            <img src={eightYahoo} alt='img'></img>
                            <h5>Name: How To Expert Title</h5>
                        </div>
                        <div className='experts_sec'>
                            <img src={eightMsn} alt='img'></img>
                            <h5>Name: How To Expert Title</h5>
                        </div>
                        <div className='experts_sec'>
                            <img src={eightCxo} alt='img'></img>
                            <h5>Name: How To Expert Title​</h5>
                        </div>
                    </div>
                </div>
            </section>

            {/* ninth section  */}
            <section className='nineSection'>
                <div className='inner_nine'>
                    <div className='custome_container'>
                        <h6>Deliverables</h6>
                        <h2>Professional Credibility</h2>
                        <p>Showcasing your achievements in the media.</p>
                        <div className='img_cover_nine'>
                            <img src={nineImg} alt='img'></img>
                        </div>
                    </div>
                </div>
            </section>

            {/* tenth section  */}
            <section className='tenSection'>
                <div className='inner_ten'>
                    <div className='custome_container'>
                        <h6>Deliverables</h6>
                        <h2>Authority Content</h2>
                        <p>Sharing your expertise with thought leadership videos.</p>
                        <div className='img_cover_ten'>
                            <img src={tenImg} alt='img'></img>
                        </div>
                    </div>
                </div>
            </section>

            {/* eleventh section  */}
            <section className='elevenSection'>
                <div className='inner_eleven'>
                    <div className='custome_container'>
                        <h6>Deliverables</h6>
                        <h2>Industry Recognition</h2>
                        <p>Gain industry respect by being featured on a local TV show.</p>
                        <div className='img_cover_eleven'>
                            <img src={elevenImg} alt='img'></img>
                        </div>
                    </div>
                </div>
            </section>

            {/* twelth section  */}
            <section className='twelvSection'>
                <div className='innner_twelv'>
                    <div className='custome_container'>
                        <h6>Deliverables</h6>
                        <h2>Expert Profile</h2>
                        <p>Stand out with an expert website showcasing your authority.</p>
                        <div className='img_cover_twelv'>
                            <img src={twelwImg} alt='img'></img>
                        </div>
                    </div>
                </div>
            </section>

            {/* thirteenth section  */}
            <section className='thirteenSection'>
                <div className='custome_container inner_thirteen'>
                    <h2>View Your Personalized Assets</h2>
                    <div className='btn_sec_thirteen'>
                        <div className='btn-left'>
                            <a href='#'>Name's Personal Website</a>
                        </div>
                        <div className='btn-right'>
                            <a href='#'>Name's Expert Piece </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* fourteenth section  */}
            <section className='fourteenSection' id="process">
                <div className='custome_container inner_fourteen'>
                    <div className='left_fourteen'>
                        <h3>Process</h3>
                        <p>Our process is designed to streamline every step, ensuring a seamless journey from initial exploration to execution.</p>
                        <a href='#'>Start Subscription</a>
                    </div>
                    <div className='right_fourteen'>
                        <div className='line'></div>
                        <div className='processes'>
                            <div className='process_icon'>
                              <svg aria-hidden="true" className="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path></svg>
                            </div>
                            <div className='process_contant'>
                                <h6>Optimize Your Online Presence</h6>
                                <p>We enhance your digital footprint to boost credibility, increase visibility, and strategically position you for key opportunities.</p>
                            </div>
                        </div>
                        <div className='processes'>
                            <div className='process_icon'>
                              <svg aria-hidden="true" className="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path></svg>
                            </div>
                            <div className='process_contant'>
                                <h6>Build Your Executive Website</h6>
                                <p>We create a professional website that highlights your expertise, attracts the right audience, and opens doors to speaking engagements.</p>
                            </div>
                        </div>
                        <div className='processes'>
                            <div className='process_icon'>
                              <svg aria-hidden="true" className="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path></svg>
                            </div>
                            <div className='process_contant'>
                                <h6>Book Your Personalized Interview</h6>
                                <p>Schedule an in-depth call where we capture your insights, expertise, and industry positioning. </p>
                            </div>
                        </div>
                        <div className='processes'>
                            <div className='process_icon'>
                              <svg aria-hidden="true" className="e-font-icon-svg e-fas-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path></svg>
                            </div>
                            <div className='process_contant'>
                                <h6>Approve & Publish Your Media</h6>
                                <p>Your content and media assets are presented in the dashboard and await your approval for publishing.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* fifteenth section  */}
            <section className='fifteenSection' id="dashboard">
                <div className='innner_fifteen'>
                    <div className='custome_container'>
                        <h6>Deliverables</h6>
                        <h2>One Dashboard</h2>
                        <p>Manage all your media assets in one intuitive platform.</p>
                        <div className='img_cover_fifteen'>
                            <img src={fifteenImg} alt='img'></img>
                        </div>
                    </div>
                </div>
            </section>

            {/* sixteenth section  */}
            <section className='sixteenSection'>
                <div className='innner_sixteen'>
                    <div className='custome_container'>
                        <h6>Step 2</h6>
                        <h2>Complete Control</h2>
                        <p>You have the final say over your media content and the release.</p>
                        <div className='img_cover_sixteen'>
                            <img src={sixteenImg} alt='img'></img>
                        </div>
                    </div>
                </div>
            </section>

            {/* seventh section  */}
            <section className='seventeenSection'>
                <div className='innner_seventeen'>
                    <div className='custome_container'>
                        <h6>Step 3</h6>
                        <h2>Social Media Assets</h2>
                        <p>Leverage our media to captivate, connect, and amplify your presence.</p>
                        <div className='img_cover_seven'>
                            <img src={seventeenImg} alt='img'></img>
                        </div>
                    </div>
                </div>
            </section>

            {/* eighteenth section  */}
            <section className='eighteenSection'>
                <div className='innner_seventeen custome_container'>
                    <h2>Missed Opportunities</h2>
                    <p>Here are the career opportunities you’re missing out on.</p>
                    <div className='opportunities_sec'>
                        <div className='opportunity_left'>
                            <img src={eighteenImg} alt='img'></img>
                        </div>
                        <div className='opportunity_right'>
                            <ul>
                                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </li>
                                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </li>
                                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </li>
                                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </li>
                                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* nineteen section  */}
            <section className='nineteenSection'>
                <div className='innner_nineteen custome_container'>
                    <h2>Future You</h2>
                    <p>A strong online presence opens doors, and opportunities show.</p>
                    <div className='future_sec'>
                        <div className='future_left'>
                            <div className='future_text'>
                                <h6>Paid Board Seats</h6>
                                <p>Get noticed and land high-paying board roles</p>
                            </div>
                            <div className='future_text'>
                                <h6>Speaking Engagements</h6>
                                <p>Command $5K-$15K per event</p>
                            </div>
                            <div className='future_text'>
                                <h6>New Career Offers</h6>
                                <p>Attract better, higher-paying roles</p>
                            </div>
                            <div className='future_text'>
                                <h6>Industry Authority</h6>
                                <p>Be the go-to expert, and doors open</p>
                            </div>
                        </div>
                        <div className='future_right'>
                            <img src={nineteenImg} alt='img'></img>
                        </div>
                    </div>
                </div>
            </section>

            {/* twenty section  */}
            <section className='twentySection' id="solution">
                <div className='innner_twenty custome_container'>
                    <h2>Solution</h2>
                    <p>Our subscription delivers a powerful, all-in-one solution to elevate your online presence—no hidden fees, no confusing tiers. One comprehensive plan gives you everything you need to build credibility, shape your narrative, and seize new opportunities, all for a clear, upfront price</p>
                    <div className='solution_sec'>
                        <div className='price_solution'>
                            <b>$950</b>
                            <span> / per month</span>
                        </div>
                        <p>The subscription engagement will be 12 months at $950 per month (with an option to opt-out on month 3 without penalties).</p>
                        <ul>
                            <li>
                                <span>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fas-check-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
                                </span>
                                8x Featured Publications (annually)</li>
                            <li>
                                <span>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fas-check-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
                                </span>
                                4x Thought Leadership Videos (annually)</li>
                            <li>
                                <span>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fas-check-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
                                </span>
                                1x TV Expert Interview (annually)</li>
                            <li>
                                <span>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fas-check-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
                                </span>
                                1x Video Asset For Each Publication (monthly)</li>
                            <li>
                                <span>
                                <svg aria-hidden="true" className="e-font-icon-svg e-fas-check-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
                                </span>
                                Executive Personal Website (complimentary)</li>
                        </ul>
                        <a href='#'>Get Started</a>
                    </div>
                </div>
            </section>

            {/* twentyone section  */}
            <section className='twentyoneSection'>
                <div className='custome_container inner_twentyone'>
                    <h2>Used By Executives Across The Globe</h2>
                    <div className='executives_img'>
                        <span className='executive_img'><img src={twentyoneGoogle} alt='img'></img></span>
                        <span className='executive_img'><img src={twentyoneWay} alt='img'></img></span>
                        <span className='executive_img'><img src={twentyonePan} alt='img'></img></span>
                        <span className='executive_img'><img src={twentyoneRec} alt='img'></img></span>
                        <span className='executive_img'><img src={twentyoneReal} alt='img'></img></span>
                        <span className='executive_img'><img src={twentyoneHein} alt='img'></img></span>
                    </div>
                </div>
            </section>

            {/* twentytwo section  */}
            <section className='twentytwoSection'>
                <div className='inner_twentytwo custome_container'>
                    <div className='twentytwo_left'>
                        <h2>Frequently Asked Questions</h2>
                    </div>
                    <div className='twentytwo_right twentytwo_accordian'>
                        {items.map((item, index) => (
                            <AccordionItem key={index} question={item.question} answer={item.answer} />
                        ))}
                    </div>
                </div>
            </section>

            {/* twentyfour section  */}
            <section className='twentyfourSection'>
                        <div className='inner_twentyFourSection custome_container'>
                            <div className='twentyfour_left'>
                                <div className='top_rating'>
                                    <b>5.0</b>
                                    <span>/ 5.0</span>
                                </div>
                                <div className='top_caption'>Average reviews based on</div>
                                <div className='twentyfour_img'>
                                    <img src={lastSEcImg} alt='img'></img>
                                </div>
                            </div>
                            <div className='twentyfour_right'>
                                <Swiper
                                    modules={[Navigation, Pagination, Autoplay]}
                                    spaceBetween={120}
                                    slidesPerView={3}
                                    autoplay={{ delay: 5000 }}
                                    loop={true}
                                    breakpoints={{
                                        0: {
                                          slidesPerView: 1,
                                          spaceBetween: 10,
                                        },
                                        768: {
                                          slidesPerView: 2,
                                          spaceBetween: 150,
                                        },
                                        1024: {
                                          slidesPerView: 3,
                                          spaceBetween: 200,
                                        },
                                        1100: {
                                          slidesPerView: 3,
                                          spaceBetween: 150,
                                        },
                                        1200: {
                                          slidesPerView: 3,
                                          spaceBetween: 120,
                                        },
                                      }}
                                >
                                    <SwiperSlide className="custom-slide">
                                        <div className='twentyfour_slide'>
                                            <div className='rating-star_sec'>
                                                <span className='starts'>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                </span>
                                            </div>
                                            <div className='rating-text'>
                                                <p>"The Whitefriar team is very competent and have a positive attitude that energizes the client. They understand their field in depth and are able to craft PR strategies that are customized and effective."</p>
                                            </div>
                                            <div className='rating-person'>
                                                <div className='person_left'>
                                                    <img src={Person1} alt='img'></img>
                                                </div>
                                                <div className='person_right'>
                                                    <h6>Juan E.</h6>
                                                    <p>Founder & Director</p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="custom-slide">
                                        <div className='twentyfour_slide'>
                                            <div className='rating-star_sec'>
                                                <span className='starts'>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                </span>
                                            </div>
                                            <div className='rating-text'>
                                                <p>"Whitefriars delivers at a fair price, and with great professionalism and care. We were very happy with their services.”</p>
                                            </div>
                                            <div className='rating-person'>
                                                <div className='person_left'>
                                                    <img src={person2} alt='img'></img>
                                                </div>
                                                <div className='person_right'>
                                                    <h6>Sara R.</h6>
                                                    <p>Founder & CEO</p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide >
                                    <SwiperSlide className="custom-slide">
                                        <div className='twentyfour_slide'>
                                            <div className='rating-star_sec'>
                                                <span className='starts'>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                </span>
                                            </div>
                                            <div className='rating-text'>
                                                <p>"The platform is easy to use and service is very intuitive. Customer service is very good and fast.”</p>
                                            </div>
                                            <div className='rating-person'>
                                                <div className='person_left'>
                                                    <img src={person3} alt='img'></img>
                                                </div>
                                                <div className='person_right'>
                                                    <h6>Dr. Ana C. D.</h6>
                                                    <p>Chief Scientific Officer</p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="custom-slide">
                                        <div className='twentyfour_slide'>
                                            <div className='rating-star_sec'>
                                                <span className='starts'>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                </span>
                                            </div>
                                            <div className='rating-text'>
                                                <p>"The Whitefriar team is very competent and have a positive attitude that energizes the client. They understand their field in depth and are able to craft PR strategies that are customized and effective."</p>
                                            </div>
                                            <div className='rating-person'>
                                                <div className='person_left'>
                                                    <img src={Person1} alt='img'></img>
                                                </div>
                                                <div className='person_right'>
                                                    <h6>Juan E.</h6>
                                                    <p>Founder & Director</p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="custom-slide">
                                        <div className='twentyfour_slide'>
                                            <div className='rating-star_sec'>
                                                <span className='starts'>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                </span>
                                            </div>
                                            <div className='rating-text'>
                                                <p>"Whitefriars delivers at a fair price, and with great professionalism and care. We were very happy with their services.”</p>
                                            </div>
                                            <div className='rating-person'>
                                                <div className='person_left'>
                                                    <img src={person2} alt='img'></img>
                                                </div>
                                                <div className='person_right'>
                                                    <h6>Sara R.</h6>
                                                    <p>Founder & CEO</p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide >
                                    <SwiperSlide className="custom-slide">
                                        <div className='twentyfour_slide'>
                                            <div className='rating-star_sec'>
                                                <span className='starts'>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                    <span className='star'>
                                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-star" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                    </span>
                                                </span>
                                            </div>
                                            <div className='rating-text'>
                                                <p>"The platform is easy to use and service is very intuitive. Customer service is very good and fast.”</p>
                                            </div>
                                            <div className='rating-person'>
                                                <div className='person_left'>
                                                    <img src={person3} alt='img'></img>
                                                </div>
                                                <div className='person_right'>
                                                    <h6>Dr. Ana C. D.</h6>
                                                    <p>Chief Scientific Officer</p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>
            </section>

            {/* twentythree section  */}
            <section className='twentythreeSection'>
                <div className='custome_container inner_twentythree'>
                    <div className='twentythree_left'>
                        <h2>Request an Online Reputation For Entire C-Suite Team</h2>
                    </div>
                    <div className='twentythree_right'>
                        <p>Grow your business eCommerce or Marketing using Lumi. If you using Lumi for your business, your business is growing fast and many advantage.</p>
                        <div className='btns-sec'>
                            <a href='#' className='signUP'>Sign up</a>
                            <a href='#' className='getDemo'>Get a demo</a>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Home;
